import React from "react";
import { Grid, useBinanceState } from "../contexts/BinanceContext";
import { GridLevelsBar } from "./GridLevelsBar";


type GridCardProps = {
    grid: Grid;
};

export const GridCard: React.FC<GridCardProps> = ({ grid }) => {
    const { prices } = useBinanceState()
    return (
        <div className="bg-white shadow rounded-xl p-6 border border-gray-200 space-y-4">

            <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">
                    Grid #{grid.id} — {grid.symbol}
                </h2>

                <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${grid.status === "running"
                        ? "bg-green-100 text-green-700"
                        : grid.status === "completed"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-red-100 text-red-700"
                        }`}
                >
                    {grid.status.toUpperCase()}
                </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div>
                    <div className="text-gray-500">Текущая цена</div>
                    <div className="font-semibold">{grid.currentPrice.toFixed(4)}</div>
                </div>

                <div>
                    <div className="text-gray-500">Step Buy</div>
                    <div className="font-semibold">{grid.stepBuy}</div>
                </div>

                <div>
                    <div className="text-gray-500">Step Sell</div>
                    <div className="font-semibold">{grid.stepSell}</div>
                </div>

                <div>
                    <div className="text-gray-500">Размер сетки</div>
                    <div className="font-semibold">{grid.gridSize}</div>
                </div>

                <div>
                    <div className="text-gray-500">Количество SOL / шаг</div>
                    <div className="font-semibold">{grid.quantityPerStep}</div>
                </div>

                <div>
                    <div className="text-gray-500">Закрыто циклов</div>
                    <div className="font-semibold">{grid.closedCycles}</div>
                </div>
            </div>

            <div className="pt-4 border-t">
                <GridLevelsBar orders={grid.orders.map(o => ({
                    id: o.id,
                    price: o.price,
                    type: o.type,
                    filled: o.status === "filled",
                }))} currentPrice={parseFloat(prices[grid.symbol])} />
            </div>

            <div className="pt-4 border-t">
                <div className="text-gray-500 text-sm">Полученная прибыль</div>
                <div
                    className={`text-lg font-bold ${grid.realizedProfit >= 0
                        ? "text-green-600"
                        : "text-red-600"
                        }`}
                >
                    {grid.realizedProfit.toFixed(4)} USDT
                </div>
            </div>
        </div>
    );
};